var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscord24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "discord-communication-interaction-message-network-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.0049 8.02342C15.9106 6.45626 13.9041 6.50031 13.9041 6.50031L13.6991 6.7346C16.1888 7.48154 17.3458 8.57992 17.3458 8.57992C13.7837 6.61873 9.24651 6.63281 5.54143 8.57992C5.54143 8.57992 6.74234 7.42287 9.37864 6.67594L9.23225 6.50012C9.23225 6.50012 7.24036 6.45626 5.1315 8.02324C5.1315 8.02324 3.02246 11.8164 3.02246 16.4885C3.02246 16.4885 4.2528 18.5975 7.48946 18.7C7.48946 18.7 8.03134 18.0556 8.47069 17.4991C6.61075 16.9426 5.90768 15.7856 5.90768 15.7856C7.07624 16.5168 8.25778 16.9744 9.73027 17.2648C12.1259 17.7579 15.1058 17.2509 17.3314 15.7856C17.3314 15.7856 16.5991 16.9719 14.6805 17.5137C15.1198 18.0556 15.6471 18.6854 15.6471 18.6854C18.8838 18.5829 20.1139 16.4738 20.1139 16.4886C20.1137 11.8166 18.0049 8.02342 18.0049 8.02342ZM8.83676 15.1265C8.01654 15.1265 7.34289 14.4088 7.34289 13.5155C7.40283 11.376 10.2857 11.3825 10.3306 13.5155C10.3306 14.4088 9.67142 15.1265 8.83676 15.1265ZM14.1823 15.1265C13.3621 15.1265 12.6884 14.4088 12.6884 13.5155C12.7542 11.3802 15.601 11.3792 15.6762 13.5155C15.6762 14.4088 15.0171 15.1265 14.1823 15.1265Z",
    fill: "#C5C5D3"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord24Px);
export default __webpack_public_path__ + "static/media/discord-24px.cb4cf07a615f2ab63618a57c35a65126.svg";
export { ForwardRef as ReactComponent };